import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProductPage from "pages/product"
import ProductAddPage from "pages/product/add"
import ProductEditPage from "pages/product/edit"
import ProductVariantPage from "pages/product/variant"
import ProductPricePage from "pages/product/price"

import ProductOption from "pages/product_option"
import ProductOptionAddPage from "pages/product_option/add"
import OrderList from "pages/order/List"
import OrderDetail from "pages/order/Detail"
import OrderEdit from "pages/order/Edit"
import Voucher from "pages/voucher/List"
import OrderPaymentList from "pages/order-payment/List"
import DebtList from "pages/debt/List"
import CustomerList from "pages/customer/List"
import Tags from "pages/tag"
import ProductCategory from "pages/category"

import ProductOptionAddParentPage from "pages/product_option/add_parentoption"


const PageRoutes = () => {
  return (
    <Routes>
      <Route path="/orders" element={<OrderList></OrderList>} />
      <Route path="/customers" element={<CustomerList></CustomerList>} />
      <Route path="/payment-confirm" element={<OrderPaymentList></OrderPaymentList>} />
      <Route path="/debt" element={<DebtList></DebtList>} />
      <Route path="/order/edit/:id" element={<OrderEdit></OrderEdit>} />
      <Route path="/order/add/:id?" element={<OrderEdit></OrderEdit>} />
      <Route path="/order/:id" element={<OrderDetail></OrderDetail>} />
      <Route path="/vouchers" element={<Voucher></Voucher>} />
      <Route path="/product/add" element={<ProductAddPage></ProductAddPage>} />
      <Route path="/product/info/:id" element={<ProductAddPage></ProductAddPage>} />
      <Route path="/product/variant/:id" element={<ProductVariantPage></ProductVariantPage>} />
      <Route path="/product/price/:id" element={<ProductPricePage></ProductPricePage>} />
      <Route path="/product/edit/:id" element={<ProductEditPage></ProductEditPage>} />
      <Route path="/products" element={<ProductPage></ProductPage>} />
      <Route path="/product_option/" element={<ProductOption></ProductOption>} />
      <Route path="/product_option/add" element={<ProductOptionAddPage></ProductOptionAddPage>} />
      <Route path="/product_option/edit/:parentid/:id" element={<ProductOptionAddPage></ProductOptionAddPage>} />
      <Route path="/product_option/add_parentoption" element={<ProductOptionAddParentPage></ProductOptionAddParentPage>} />
      <Route path="/product_option/edit_parentoption/:id" element={<ProductOptionAddParentPage></ProductOptionAddParentPage>} />
      <Route path="/product_tag/" element={<Tags></Tags>} />
      <Route path="/product_category/" element={<ProductCategory></ProductCategory>} />

      <Route path="/" element={<OrderList></OrderList>} />

    </Routes>
  );
};

export default React.memo(PageRoutes);
